import { Component, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { OnDestroy } from '@angular/core/src/metadata/lifecycle_hooks';
//import { OwlCarousel } from 'ngx-owl-carousel';

import { ConfigService, BannerSharedService, VirtualBetSlip } from 'baseline-lib';
import { SharedService } from 'baseline-lib';
import { Event, RaceEventStatus } from 'baseline-lib';
import { game } from 'baseline-lib';
import { Market } from 'baseline-lib';
import { MobileSharedService } from 'baseline-lib';
import { EventListing } from 'baseline-lib';
import { EventListingService } from 'baseline-lib';
import { VirtualService } from 'baseline-lib';
import { VirtualBetPanelService } from 'baseline-lib';
import { ChangeDetectorRef } from '@angular/core';

 
@Component({
  selector: 'app-event-listing',
  templateUrl: 'event-listing.html',
})
export class EventListingComponent implements OnInit, OnDestroy {
  current_copy: any;
  futuredraw: boolean;
  pastevents: any[]= [];
  virtualBetSlip: VirtualBetSlip;
  removebetslips: any[]=[];
  selectedevent: Event;
  @Input() gameObj: game;
  _imageUrl: any;
  EventListObj: EventListing;
  eventId: number;
  eventSub: any;
  showViewer: boolean = false;
  sportType: number = 1;
  evn: any;
  drawex:any;
  // 1- racing
  // 2 - leagues
  // 3 - spots (player vs player)
  _currencySymbol: string;
  isAutoLoadingCompleted : boolean = true;

 // @ViewChild('owlElement') owlElement: OwlCarousel
  // current_eid: any;

  constructor(
    public mobileSharedService: MobileSharedService,
    private _configService: ConfigService,
    private _eventListingService: EventListingService,
    private _sharedService: SharedService,
    private _virtualService: VirtualService,
    public _virtualBetPanelService : VirtualBetPanelService,
    public _bannerSharedService: BannerSharedService,
    private ref: ChangeDetectorRef 
    
  ) {
    this.EventListObj = new EventListing();
    this._imageUrl = this._configService.getImageUrl();
    this._currencySymbol = this._sharedService._sessionService.getCurrenySymbol();
    this.virtualBetSlip = new VirtualBetSlip();
  }

  ngOnInit() {
    this._bannerSharedService.getBannerLists(this._sharedService.selectedGameType.gtid);   
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.gameObj) {
      this.reset();      
      if (this.EventListObj.selectedEvent)
        this.EventListObj.selectedEvent.entryList = [];
      this.EventListObj.gameObj = changes.gameObj.currentValue as game;
      this._eventListingService.EventListObj.gameObj = this.EventListObj.gameObj;
      this.sportType = this._eventListingService.formulateSportType(this.EventListObj.gameObj.gameid);
      this._virtualBetPanelService.clearallBetPanels();      
      this._virtualBetPanelService.betidCounter = 0;
      this.EventListing();
    }
  }
  backclick() {
    this.mobileSharedService.gamelistHide = false;
  }
  EventListing() {
    this._sharedService.showLoader();
    this.eventSub = this._virtualService.getEventList(this.EventListObj.gameObj.companygames[0].gameid).subscribe(
      data => {
        let marketList: Market[] = [];
        // for leagues data map the mgli object        
        if (data.mgli) {
          data.mgli.forEach(_market => {
            var _m = new Market();
            _m.constructMarket(_market);
            marketList.push(_m);
         });
        }
        if (data.eli) {
          data.eli.forEach(_event => {
            var _e = new Event();
            if (marketList.length > 0)
              _e.mgli = marketList;
            _e.constructEvent(_event, 2, false);
            if(_e.odt > this._sharedService.getServerTime()){
              if(this.sportType == 2 && _event.lm) {
                let tempEvent = this.EventListObj.eventList.find(evt => evt.odt == _e.odt);                
                if(tempEvent)
                  tempEvent.egli.push(_e);
                else {
                  _e.egli.push(_e);
                  this.EventListObj.eventList.push(_e);
                } 
              }             
              else {
                this.EventListObj.eventList.push(_e);
              }
            
            }
          });
        }
        this._sharedService.hideLoader();
        if (this.EventListObj.eventList && this.EventListObj.eventList.length > 0) {
          this.filterEvents(this._sharedService.getServerTime());
          if (this._eventListingService.EventListObj.resultEvent && this.EventListObj.eventList.filter(e => e.eventid == this._eventListingService.EventListObj.resultEvent.eventid).length == 0) {
            // for leagues set market list
            if (this.sportType == 2) {
              this._eventListingService.EventListObj.resultEvent.mli = this.EventListObj.eventList[0].mli;
              this._eventListingService.EventListObj.resultEvent.fromMyBets = true;
              if (this._eventListingService.EventListObj.resultEvent.mli.length > 0) {
                this.EventListObj.selectedMarket = this._eventListingService.EventListObj.resultEvent.mgli[0];
                this._eventListingService.EventListObj.resultEvent.mli[0].isSelected = true;
              }
            }
            this.EventListObj.eventList.splice(0, 0, this._eventListingService.EventListObj.resultEvent).join();
          }
          this.navigateToFirstEvent();
        }
      },
      error => {
        this._sharedService.hideLoader();
      });
  }
  menuclick(){
    this.mobileSharedService.gamelistHide = false;
  }
  public filterEvents(time: Date) {
    var pastEvents = [];
    if (this.EventListObj.eventList) {
      if (this.EventListObj.eventList.length > 0) {
        let indxFuture = 0, indxPast = 0;
        if (this.EventListObj.eventList.filter(e => e.isFuture).length >= 0) {
          if (this.EventListObj.eventList.filter(e => e.isFuture).length == 0 || new Date(this.EventListObj.eventList.filter(e => e.isFuture)[0].odt).getTime() <= time.getTime()) {
            this.EventListObj.eventList.forEach(a => {
              a.isPast = false;
              a.isCurrent = false;
              // a.isSelected = false;
              a.isFuture = false;
              if (new Date(a.odt).getTime() >= time.getTime()) {
                if (indxFuture == 0)
                  a.isFuture = true;
                indxFuture++;
                
              }
              else if (a.odt == undefined || new Date(a.odt).getTime() <= time.getTime()) {
                a.isPast = true;
              }

            }
            );
            pastEvents = this.EventListObj.eventList.filter(e => e.isPast).sort((e1, e2) => (e1.odt > e2.odt) ? 1 : 0);
            
            if (pastEvents.length > 0) {
              this.showViewer = false;
              pastEvents[pastEvents.length - 1].isCurrent = true;
              this.current_copy = pastEvents[pastEvents.length - 1].isCurrent;
              this._virtualService.current_eid = pastEvents[pastEvents.length - 1].eventid;
              //  var panel_ex = [];
              var i=0;
              for(i=this._virtualBetPanelService.virtualBetSlip.betpanels.length-1; i >= 0; i--){
                if(this._virtualService.current_eid == this._virtualBetPanelService.virtualBetSlip.betpanels[i].eid)
             {
this._virtualBetPanelService.removeBetPanel(this._virtualBetPanelService.virtualBetSlip.betpanels[i]);
             }
              }
              //  var panel_ex = this._virtualBetPanelService.virtualBetSlip.betpanels[0].pid;
              //  panel_ex.forEach(element => {
              //    if(element.eid ==  this._virtualService.current_eid){
              //     this._virtualBetPanelService.virtualBetSlip.removePanel(element);
              //    }
  
// });
              
       
              if (pastEvents.length > 10) {
           
                this.EventListObj.eventList.splice(0, 8);
                //this.owlElement.$owlChild.currentSlideIndex = 1;
                this.navigateToFirstEvent();
              }

              if (pastEvents.length > 5) {
                //if (this.owlElement.$owlChild.currentSlideIndex == 0)
                  //this.owlElement.$owlChild.currentSlideIndex = 1;

                //this.owlElement.$owlChild.currentSlideIndex++;
                //this.owlElement.next();
              }

              if (this._eventListingService.EventListObj.selectedEvent.sts != RaceEventStatus.WINNERSCANRAN){
                if(this.sportType == 2 && pastEvents.length > 0)
                  this._eventListingService.marketlisting(this.sportType, 0);
                else 
                  this._eventListingService.marketlisting(this.sportType, 0);
              }
            }
            /*if(this.EventListObj.selectedEvent && (this.EventListObj.eventList.filter(e => e.isFuture)[0].eventid != this.EventListObj.selectedEvent.eventid))
              this.navigateToFirstEvent(); */
          }
        }

      }
    }
  }

  private setSelectedEvent() {
    this.EventListObj.selectedEvent.isSelected = true;
    this.EventListObj = this._eventListingService.EventListObj;
    this.eventId = this.EventListObj.selectedEvent.eventid;
  }

  private navigateToFirstEvent() {
    var pastEvents = this.EventListObj.eventList.filter(e => e.isPast).sort((e1, e2) => (e1.odt > e2.odt) ? 1 : 0);
    if (pastEvents.length > 0) {

      this.EventListObj.selectedEvent = pastEvents[pastEvents.length-1];
      if (!this.EventListObj.selectedEvent.fromMyBets && this.EventListObj.selectedEvent.sts != RaceEventStatus.WINNERSCANRAN)
        this.EventListObj.selectedEvent.isCurrent = true;
      this.EventListObj.selectedEvent.isSelected = true;
    }
    else {

      this.EventListObj.selectedEvent = this.EventListObj.eventList[0];
      if (this.EventListObj.selectedEvent)
        this.EventListObj.selectedEvent.isSelected = true;
    }

    // if(this.EventListObj.selectedEvent)
    // 

  if (this.sportType == 2)
      this.EventListObj.selectedMarket = this.EventListObj.selectedEvent.mgli[0];
    this._eventListingService.EventListObj = this.EventListObj;
    this.eventChange(this.EventListObj.selectedEvent.odt);
    if (this.EventListObj.selectedEvent.sts == RaceEventStatus.WINNERSCANRAN) {
      this.setSelectedEvent();
      this._eventListingService.fetchBetResultsData(this.sportType, 0);
    }
    else if(this.sportType !==2){
      this._eventListingService.marketlisting(this.sportType, 0).subscribe(
        data => {
          if (this.EventListObj.selectedEvent) {
            this.setSelectedEvent();
          }
        });
    
      }

      // 
  }

  private setSelectedEventOnChange(_event) {
    this._eventListingService.EventListObj.selectedEvent = _event;
    this.eventId = this.EventListObj.selectedEvent.eventid;
  }


  public eventChange(_event) {
    this.drawex;

    this._sharedService.showLoader();
    this.EventListObj.eventList.forEach(element => {
      if(element.odt == _event){
        this.drawex = _event;
        element.isSelected = true;
        this.selectedevent = element;
      }
      else{
        element.isSelected = false;
      }
      
    });

    // _event.isSelected = true;
    this.EventListObj.selectedEvent = this.selectedevent;

    if (this.EventListObj.selectedEvent.sts == RaceEventStatus.WINNERSCANRAN) {
      if (this.sportType == 1)
        this._eventListingService.formulateSilkNumber(this.selectedevent, this._eventListingService.EventListObj.gameObj);
      this.setSelectedEventOnChange(this.selectedevent);
      this._sharedService.hideLoader();
    }
    else {

      // to load earlier populated event 
      if (!this.selectedevent.isPast && (this.sportType == 1 || this.sportType == 3) && this.EventListObj.eventList.filter(_e => _e.eventid == this.selectedevent.eventid)[0].mli) {
        this.setSelectedEventOnChange(this.selectedevent);
        this._sharedService.hideLoader();
      }
      else if (!this.selectedevent.isPast && this.sportType == 2 && this.EventListObj.eventList.filter(_e => _e.eventid == this.selectedevent.eventid)[0].marketEvents) {
        this.resetMarketsSelected();
        if (this.selectedevent.mli.length > 0) {
          this.EventListObj.selectedMarket = this.selectedevent.mgli[0];
          this.selectedevent.mli[0].isSelected = true;
        }
        this.setSelectedEventOnChange(this.selectedevent);
        this._sharedService.hideLoader();
      }
      // to load data for newly selected event 
      else {
        this.EventListObj.selectedEvent.entryList = [];
        if (this.sportType != 2)
          this.EventListObj.selectedEvent.mli = [];
        else {
          this.resetMarketsSelected();
        }

        this.EventListObj.selectedEvent.otherMli = [];
        this._sharedService.hideLoader();

        this._eventListingService.marketlisting(this.sportType, 0).subscribe(
          data => {
            if (this.EventListObj.selectedEvent) {
              this.setSelectedEvent();
            }
          });
      }
    }
  }

  resetMarketsSelected() {
    if(this.sportType == 2) {
      this.EventListObj.eventList.forEach(element => {
        element.mgli.forEach(market => {
          market.isSelected = false;
        });
      })
    }
    else {
      this.EventListObj.eventList.forEach(element => {
        element.mli.forEach(market => {
          market.isSelected = false;
        });
      })
    }
  }
  showbetslip() {
    this.mobileSharedService.betslipshow = true;
  }
  private reset() {
    this.sportType = 1;
    this.EventListObj.eventList = [];
    this.EventListObj.selectedEvent = undefined;
  }
  /* Draw List Carousel Init method */
  public initDrawlistCarousel(event) { 
    event.relatedTarget.options.margin = 20;
    event.relatedTarget.options.responsiveClass = true;
    event.relatedTarget.options.responsive = {
      0: {
        items: 2,
        nav: true
      },
      768: {
        items: 8,
        nav: false
      },
      1100: {
        items: 16,
        nav: true,
        loop: false,
        margin: 0
      }
    }
  }

  refreshNow(){
    // this._sharedService.showLoader();
    this.filterEvents(this._sharedService.getServerTime());
    // this._sharedService.hideLoader();
  }

  refreshDrawList() {
    this._sharedService.showLoader();
    this.filterEvents(this._sharedService.getServerTime());
    this._sharedService.hideLoader();
    // this.EventListing();
    // this.setSelectedEvent();
    // this.ngOnInit();
    for(let c=0; c<this.EventListObj.eventList.length; c++){
      if(this.EventListObj.eventList[c].isFuture){
        this.isAutoLoadingCompleted = false;
        // this.drawex = this.EventListObj.eventList[c].odt;
        setTimeout(() => {
          this.isAutoLoadingCompleted = true;
          this.eventChange(this.EventListObj.eventList[c].odt);
          // this.showViewer = true;
        }, 1000);
       
        // this.ref.detectChanges();
        break;
      }
    }
  }

  toggleViewer(){
    this.showViewer = !this.showViewer;
  }

  ngOnDestroy() {
    if (this.eventSub) {
      this.eventSub.unsubscribe();
    }
    this._eventListingService.gameList = undefined;
  }
}


// WEBPACK FOOTER //
// ./src/app/virtual-sports/event-listing/event-listing.ts